export function translatePaymentMethodId(paymentMethodId: number): string {
  switch (paymentMethodId) {
    case 1:
      return 'Dinheiro'
    case 2:
      return 'Cartão de crédito'
    case 3:
      return 'Cartão de débito'
    case 4:
      return 'Pix'
    default:
      return ''
  }
}
